<template>
    <g>
        <marker
            :id="markerId"
            viewBox="0 0 10 10"
            refX="9"
            refY="5"
            markerUnits="strokeWidth"
            markerWidth="10"
            markerHeight="10"
            orient="auto-start-reverse"
        >
            <path d="M 0 0 L 10 5 L 0 10 z" :fill="color" />
        </marker>

        <foreignObject v-if="markers" width="105" height="50" :x="x + 10" :y="y - 70">
            <div xmlns="http://www.w3.org/1999/xhtml">
                <div><span>x:</span> <NumberInput :value="value.x" @input="e => $emit('input', { x: e, y: value.y })" />mm</div>
                <div><span>y:</span> <NumberInput :value="value.y" @input="e => $emit('input', { x: value.x, y: e })" />mm</div>
            </div>
        </foreignObject>
        <line :x1="x - 10" :x2="x + 10" :y1="y - 10" :y2="y + 10" :stroke="color"></line>
        <line :x1="x - 10" :x2="x + 10" :y1="y + 10" :y2="y - 10" :stroke="color"></line>
        <foreignObject v-if="canDelete && markers" width="50" height="50" :x="x + 110" :y="y - 55">
            <button @click="$emit('delete');" xmlns="http://www.w3.org/1999/xhtml" v-if="canDelete">x</button>
        </foreignObject>
    </g>
</template>

<script>
import { createUUID } from "@/utils/string";
import NumberInput from "@/plano/components/number-input";

export default {
    components: { NumberInput },
    props: {
        x: { required: true, type: Number },
        y: { required: true, type: Number },
        value: { required: true, type: Object },
        color: { type: String, default: "purple" },
        canDelete: { type: Boolean, default: false },
        markers: { type: Boolean, default: true }
    },
    data: () => ({ markerId: undefined }),
    created() {
        this.markerId = createUUID();
    }
};
</script>

<style lang="scss" scoped>
line {
    stroke-width: 2px;
}

foreignObject > div > div {
    display: flex;
    align-items: center;
    height: 22px;

    span {
        margin-right: 2px;
    }

    & + div {
        margin-top: 5px;
    }
}
foreignObject:hover + line,
foreignObject:hover + line + line {
    stroke-width: 3px;
}
input {
    width: 65px;
}
</style>



// WEBPACK FOOTER //
// point.vue?5a2b7ed4